import { computed } from 'vue';
import { LoadingStatuses } from '@/models/loading.interface';
import campaignPresenter from '@/presenters/campaign-presenter';
import store from '@/store';

export default class GeneralCode {
	public isLoading = computed((): boolean => {
		const loadingStatus = store.getters.loadingStatusPrimaryData();
		return loadingStatus === LoadingStatuses.ACTIVE;
	});

	public mounted(): void {
		store.mutations.incrementLoadCount();

		void this.loadOptionalData();
	}

	private async loadOptionalData(): Promise<void> {
		await Promise.all([
			campaignPresenter.prepareAccountManagers(),
			campaignPresenter.prepareClientServicesPeople()
		]);
	}
}
